import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children"];
import PropTypes from 'prop-types';
import React from 'react';
import { withIcon } from '../Icon';
var innerSvg = '<path d="M17 22.3V19a1 1 0 00-2 0v3.3a2 2 0 00-1 1.7 2 2 0 004 0 2 2 0 00-1-1.7z"/><path d="M25 14H11V8a4 4 0 014-4h2a4 4 0 014 4 1 1 0 002 0 6 6 0 00-6-6h-2a6 6 0 00-6 6v6H7a2 2 0 00-2 2v12a2 2 0 002 2h18a2 2 0 002-2V16a2 2 0 00-2-2zm0 14H7V16h18z"/>';
export var UnlockOutlineSVG = function UnlockOutlineSVG(_ref) {
  var children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    dangerouslySetInnerHTML: {
      __html: innerSvg
    }
  }));
};
UnlockOutlineSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node
} : {};
export default withIcon(UnlockOutlineSVG);